import { NgModule } from '@angular/core';

import { FormatTimeAgoPipe } from './pipes/format-time-ago.pipe';
import { PluralizePipe } from './pipes/pluralize.pipe';
import { SortMatchHighlightsPipe } from './pipes/sort-match-highlights.pipe';
import { UnsafeHtmlPipe } from './pipes/unsafe-html.pipe';

const PIPES = [
  PluralizePipe,
  SortMatchHighlightsPipe,
  UnsafeHtmlPipe,
];

@NgModule({
  // Standalone pipes
  imports: [FormatTimeAgoPipe],
  declarations: [
    ...PIPES,
  ],
  exports: [
    FormatTimeAgoPipe,
    ...PIPES
  ]
})
export class PipesModule {}
